// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_enum-bug-keys.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_enum-bug-keys.js
// module chunks = 168707334958949